import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import AppPayment from './AppPayment';
import AppPaymentUI2 from './AppPaymnet_1';
import { BRAND_COPYRIGHT } from '../../Common/config/brandConfig';

function AppPaymentPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const [uiMode, setUiMode] = useState(() => (location.state?.preferB ? 'B' : 'A'));

    useEffect(() => {
        if (location.state?.preferB) setUiMode('B');
    }, [location.state?.preferB]);

    const getDashboardPath = () => {
        if (location.state?.from) return location.state.from;
        if (location.pathname.startsWith('/app')) return '/app/dashboard';
        if (location.pathname.startsWith('/cp')) return '/cp/dashboard';
        return '/dashboard';
    };

    return (
        <div style={{
            minHeight: '100dvh',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: '768px',
            margin: '0 auto',
            background: '#FFFFFF',
            overflowX: 'hidden',
            boxSizing: 'border-box',
        }}>
            {/* 헤더: 뒤로가기 + 수기결제 + 토글(UI A | UI B) */}
            <div style={{
                background: 'linear-gradient(160deg, var(--brand-gradient-start) 0%, var(--brand-gradient-mid) 60%, var(--brand-gradient-end) 100%)',
                height: '62px',
                padding: '0 12px 0 10px',
                color: '#FFFFFF',
                display: 'flex',
                alignItems: 'center',
                boxSizing: 'border-box',
                flexShrink: 0,
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0 2px',
                    position: 'relative',
                    width: '100%',
                }}>
                    <button
                        onClick={() => navigate(getDashboardPath())}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            padding: '2px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <ChevronLeft size={28} color="#FFFFFF" />
                    </button>
                    <h1 style={{
                        position: 'absolute',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        fontSize: '16px',
                        fontWeight: 700,
                        color: '#FFFFFF',
                        margin: 0,
                    }}>
                        수기결제
                    </h1>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0,
                        background: 'rgba(255,255,255,0.25)',
                        borderRadius: '10px',
                        padding: '3px',
                        border: '1px solid rgba(255,255,255,0.4)',
                        boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.1)',
                    }}>
                        <button
                            type="button"
                            onClick={() => setUiMode('A')}
                            style={{
                                padding: '3px 10px',
                                fontSize: uiMode === 'A' ? '15px' : '13px',
                                fontWeight: 700,
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                background: uiMode === 'A' ? '#FFFFFF' : 'transparent',
                                color: uiMode === 'A' ? 'var(--brand-gradient-mid)' : 'rgba(255,255,255,0.7)',
                                boxShadow: uiMode === 'A' ? '0 2px 6px rgba(0,0,0,0.15)' : 'none',
                                // transition: 'all 0.2s ease',
                            }}
                        >
                            A
                        </button>
                        <button
                            type="button"
                            onClick={() => setUiMode('B')}
                            style={{
                                padding: '3px 10px',
                                fontSize: uiMode === 'B' ? '15px' : '13px',
                                fontWeight: 700,
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                background: uiMode === 'B' ? '#FFFFFF' : 'transparent',
                                color: uiMode === 'B' ? 'var(--brand-gradient-mid)' : 'rgba(255,255,255,0.7)',
                                boxShadow: uiMode === 'B' ? '0 2px 6px rgba(0,0,0,0.15)' : 'none',
                                // transition: 'all 0.2s ease',
                            }}
                        >
                            B
                        </button>
                    </div>
                </div>
            </div>

            {/* 본문: UI A = AppPayment, UI B = AppPaymnet_1 */}
            <div style={{ flex: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                {uiMode === 'A' && <AppPaymentUI2 hideHeader />}
                {uiMode === 'B' && <AppPayment hideHeader />}
            </div>

            <footer
                style={{
                    flexShrink: 0,
                    paddingTop: '0.5rem',
                    paddingBottom: '0.5rem',
                    textAlign: 'center',
                    fontSize: '12px',
                    color: '#8b95a1',
                    borderTop: '1px solid #f2f4f6',
                }}
            >
                {BRAND_COPYRIGHT}
            </footer>
        </div>
    );
}

export default AppPaymentPage;
